import { useRef, useState } from 'react';
import { Icon } from '@iconify/react';

// material
import { MenuItem, ListItemIcon, ListItemText, ListItem, Menu } from '@mui/material';

import PropTypes from 'prop-types';

import { useTranslation } from '../../common/LocalizationProvider';

// ----------------------------------------------------------------------

FlightListTimeLinePoint.propTypes = {
  reportTrip: PropTypes.object.isRequired
};

export default function FlightListTimeLinePoint({ reportTrip }) {
  const t = useTranslation();
  const ref = useRef(null);

  const [isOpen, setIsOpen] = useState(false);
  const handleIsOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <MenuItem
        sx={{ color: 'text.secondary' }}
        onClick={handleIsOpen}
        disabled={reportTrip.affectationVolsId === 0}
        ref={ref}
      >
        <ListItemIcon>
          {!isOpen ? (
            <Icon icon="ant-design:plus-circle-outlined" width={24} height={24} />
          ) : (
            <Icon icon="ant-design:minus-circle-outlined" width={24} height={24} />
          )}
        </ListItemIcon>
        <ListItemText
          primary={t('Total_Point')}
          secondary={reportTrip.totalPoint || 0}
          primaryTypographyProps={{ variant: 'body2' }}
        />
      </MenuItem>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%', overflow: 'auto' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <ListItem>
          <ListItemIcon>
            <Icon
              icon={
                reportTrip.pointNewAD > 0
                  ? 'emojione-v1:ballot-box-bold-check'
                  : 'ic:outline-check-box-outline-blank'
              }
              width={24}
              height={24}
            />
          </ListItemIcon>
          <ListItemText
            primary={t('Point_New_AD')}
            secondary={`${Math.round(reportTrip.pointNewAD / 30)} x 30 points`}
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Icon
              icon={
                reportTrip.pointTrip > 0
                  ? 'emojione-v1:ballot-box-bold-check'
                  : 'ic:outline-check-box-outline-blank'
              }
              width={24}
              height={24}
            />
          </ListItemIcon>
          <ListItemText
            primary={t('Point_Trip')}
            secondary="10 points"
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Icon
              icon={
                reportTrip.pointAlert > 0
                  ? 'emojione-v1:ballot-box-bold-check'
                  : 'ic:outline-check-box-outline-blank'
              }
              width={24}
              height={24}
            />
          </ListItemIcon>
          <ListItemText
            primary={t('Point_Alert')}
            secondary="10 points"
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Icon
              icon={
                reportTrip.pointLanding > 0
                  ? 'emojione-v1:ballot-box-bold-check'
                  : 'ic:outline-check-box-outline-blank'
              }
              width={24}
              height={24}
            />
          </ListItemIcon>
          <ListItemText
            primary={t('Point_Landing')}
            secondary={`${reportTrip.landing} x 5 points`}
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Icon
              icon={
                reportTrip.pointPerfectLanding > 0
                  ? 'emojione-v1:ballot-box-bold-check'
                  : 'ic:outline-check-box-outline-blank'
              }
              width={24}
              height={24}
            />
          </ListItemIcon>
          <ListItemText
            primary={t('Point_Perfect_Landing')}
            secondary={`${reportTrip.perfectLanding} x 5 points`}
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Icon
              icon={
                reportTrip.pointBonus > 0
                  ? 'emojione-v1:ballot-box-bold-check'
                  : 'ic:outline-check-box-outline-blank'
              }
              width={24}
              height={24}
            />
          </ListItemIcon>
          <ListItemText
            primary={t('Point_Bonus')}
            secondary="25 points"
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Icon
              icon={
                reportTrip.pointRemarquableTrace > 0
                  ? 'emojione-v1:ballot-box-bold-check'
                  : 'ic:outline-check-box-outline-blank'
              }
              width={24}
              height={24}
            />
          </ListItemIcon>
          <ListItemText
            primary={t('Point_Remarquable_Trace')}
            secondary="200 points"
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </ListItem>
      </Menu>
    </>
  );
}
